import { Box, Typography } from '@mui/material';
import { SurveyV2, UserDto } from '@act/shared/data-transfer-objects';
import { applyMustacheTemplate } from '@act/shared/utilities';

export interface SurveyTitleSectionProps {
  survey: SurveyV2.SurveyDto;
  member: UserDto;
}

const SurveyTitleSection = ({ survey, member }: SurveyTitleSectionProps) => {
  // Early return if no member data
  if (!member) {
    return (
      survey?.displayName && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            padding: '8px 0 16px',
          }}
        >
          <Typography display="block" variant="headlineMedium">
            {survey.displayName || ''}
          </Typography>
          <Typography variant="bodyLarge">{survey.summary || ''}</Typography>
        </Box>
      )
    );
  }

  const surveyTemplateVariables = {
    memberName: `${member?.firstName}`,
    month: new Date().toLocaleString('default', { month: 'long' }),
  };
  const surveyTitle = applyMustacheTemplate(survey?.displayName || '', surveyTemplateVariables);

  return (
    (survey?.displayName || survey?.summary)  && (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          padding: '8px 0 16px',
        }}
      >
        <Typography display="block" variant="headlineMedium">
          {surveyTitle}
        </Typography>
        <Typography variant="bodyLarge">
          {survey.summary
            ? applyMustacheTemplate(survey.summary, surveyTemplateVariables)
            : ''}
        </Typography>
      </Box>
    )
  );
};

export default SurveyTitleSection;
